import {deserialize} from 'libs/cerialize';

export class SpreadsheetCellPositionDto {
    @deserialize
    Column: string;

    @deserialize
    Row: number;
}
